module.exports = __webpack_public_path__ + "img/9788956243207.cfe8db72.jpg";